import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Grid, Checkbox, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import Service from '../../apis/service';
import AntSwitch from '../dailydose/AntSwitch';
import ConfirmPopup from './ComfirmPopup';
import {
  getAllDepartments,
  getDepartmentRole,
  getSelectedDeptRoles,
  getTempChecksDept,
  getTempChecksRoles,
  showProgress,
} from '../../redux/actions/DealershipActions';
import Theme from '../ui/Theme';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import DepartmentRoleMapping from './DepartmentRoleMapping';
import JourneyRuleSelectMapping from './JourneyRuleSelectMapping';
import { apiEndpoints } from '../../constants/apiEndpoints';

const useStyles = makeStyles(() => ({
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  popupHeading: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '22px',
    fontStyle: 'normal',
    marginBottom: '10px',
    marginTop: '0px',
  },
  connectingLine: {
    position: 'relative',
    margin: '10px 0',
    width: '100%',
    borderTop: 'solid 1px grey',
    '&:before': {
      content: "'1'",
      width: '20px',
      height: '20px',
      left: '0px',
      top: '-11px',
      border: '0.3px solid rgba(98, 47, 238, 0.3)',
      borderRadius: '50%',
      background: '#622FEE',
      boxSizing: 'border-box',
      textAlign: 'center',
      fontSize: '10px',
      color: '#FFFFFF',
      alignItems: 'center',
      padding: '3px',
      position: 'absolute',
    },
  },
  connectingLineText1: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#622FEE',
  },
  connectingLineText2: {
    width: '131px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: '#622FEE',
  },
  connectingLine2: {
    position: 'relative',
    margin: '10px 0',
    width: '100%',
    '&:before': {
      content: "'2'",
      width: '20px',
      height: '20px',
      left: '0px',
      top: '-11px',
      border: '0.3px solid rgba(98, 47, 238, 0.3)',
      borderRadius: '50%',
      background: '#622FEE',
      boxSizing: 'border-box',
      textAlign: 'center',
      fontSize: '10px',
      color: '#FFFFFF',
      alignItems: 'center',
      padding: '3px',
      position: 'absolute',
    },
  },
  isMandatoryText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    marginRight: '20px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  assignToText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '140%',
    marginRight: '20px',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
  },
  journeyAssignText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '140%',
    color: '#1D2939',
  },
  smallRadioButton: {
    '& svg': {
      width: '0.8em',
      height: '0.8em',
    },
  },
  radioButton: {
    height: '5px',
    width: '5px',
  },
  horizontalLine: {
    border: '1px solid #E4E7EC',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px',
    marginTop: '5px',
  },
  cardContent: {
    marginRight: '10px',
    marginTop: '10px',
    marginBottom: '10px',
    border: 0,
    backgroundColor: '#F2F4F7',
  },
  scrollContent: {
    marginTop: '10px',
    width: '100%',
    maxHeight: '300px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  orCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
  },
  chipOrCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '13px',
    lineHeight: '13px',
  },
  andCondition: {
    textAlign: 'center',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  chipStyle: {
    backgroundColor: '#F2F4F7',
    marginTop: '5px',
    marginBottom: '5px',
    marginRight: '3px',
    marginLeft: '3px',
  },
  selectRule: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '25px',
    textTransform: 'uppercase',
    color: '#667085',
  },
}));

const RoleMapping = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [viewJourneyPop, setViewJourneyPop] = useState(props.open);
  const [selectedDeptRoles, setSelectedDeptRoles] = useState([]);
  const [selectedDept, setSelectedDept] = useState([]);
  const [showComfirmPopup, setShowConfirmPopup] = useState(false);
  const [assignJourneyTo, setAssignJourneyTo] = useState('departments');
  const [selectedRuleObj, setSelectedRuleObj] = useState({
    selectedRule: null,
    mandatoryRuleCoditions: {},
  });
  const [ruleList, setRuleList] = useState([]);

  const [isCheckJourneyDone, setIsCheckJourneyDone] = useState(false);

  const departmentList = useSelector((state) => state.getAllDepartments.departments);
  const tempDeptCheckList = useSelector((state) => state.getTempChecksDept.tempCheckDept);
  const tempRoleCheckList = useSelector((state) => state.getTempChecksRoles.tempCheckRoles);
  const deptRoles = useSelector((state) => state.getDepartmentRole);
  deptRoles?.sort((a, b) => a[0].departmentId - b[0].departmentId);
  const selDeptRoles = useSelector((state) => state.getSelectedDeptRoles.selDeptRoles);

  const getDepartments = async () => {
    const data = '';
    await Service.get(apiEndpoints.GET_DEPARTMENTS, data)
      .then((response) => {
        dispatch(showProgress(true));
        dispatch(getAllDepartments(response));
        const tmpDept = response;
        tmpDept.sort((a, b) => a.id - b.id);
        tmpDept?.map((val) => getDepartmentRoles(val.id));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const checkJourney = async () => {
    if (props.edit === true) {
      dispatch(showProgress(true));
      await Service.get(apiEndpoints.RULES_JOURNEY_CHECK.replace('ID', props.id))
        .then((res) => {
          dispatch(showProgress(true));
          dispatch(getDepartmentRole('clear', []));
          dispatch(getSelectedDeptRoles('clear', []));
          if (res === 'departments') {
            setAssignJourneyTo(res);
            getDepartments();
          } else {
            setAssignJourneyTo(res);
            getRuleIdForJourney(props.id);
          }
          setIsCheckJourneyDone(true);
        })
        .catch((error) => {
          console.log(error);
          setIsCheckJourneyDone(true);
        });
    } else {
      setAssignJourneyTo('departments');
      getDepartments();
      setIsCheckJourneyDone(true);
    }
  };

  useEffect(() => {
    checkJourney();
  }, []);

  useEffect(() => {
    // This is a temporary solution. For a proper solution we need 1 API to get all this data
    if (deptRoles.length === 4) {
      dispatch(showProgress(false));
    }
  }, [deptRoles]);
  useEffect(() => {
    if (assignJourneyTo === 'departments' && isCheckJourneyDone) {
      if (props.edit === true) {
        if (tempRoleCheckList === undefined || tempRoleCheckList?.length === 0) {
          getRolesAssignedToJourney(props.id);
        } else {
          setTempCheck();
        }
      } else if (tempRoleCheckList === undefined || tempRoleCheckList?.length === 0) {
        setAllRolesSelected();
      } else {
        setTempCheck();
      }
    }
  }, [deptRoles]);

  useEffect(() => {
    if (isCheckJourneyDone) {
      if (assignJourneyTo === 'departments') {
        getDepartments();
      } else {
        getRuleIdForJourney(props.id);
        dispatch(getDepartmentRole('clear', []));
        dispatch(getSelectedDeptRoles('clear', []));
        setSelectedDept([]);
        setSelectedDeptRoles([]);
      }
    }
  }, [assignJourneyTo]);

  const setTempCheck = () => {
    const tempValue = [];
    const tempDept = [];
    tempRoleCheckList.forEach((v) => {
      deptRoles.forEach((value) => {
        value.forEach((val) => {
          if (v.id === val.id) {
            tempValue.push({
              id: val.id,
              departmentId: val.departmentId.toString(),
              mandatory: v.mandatory,
            });
          }
        });
      });
    });
    tempDeptCheckList.map((val) => tempDept.push(val.toString()));
    setSelectedDeptRoles(tempValue);
    setSelectedDept(tempDept);
    dispatch(getSelectedDeptRoles('add', tempValue));
  };

  const getRuleIdForJourney = async (id) => {
    dispatch(showProgress(true));

    await Service.post(apiEndpoints.JOURNEY_LIST, { journeyId: id })
      .then((res) => {
        setSelectedRuleObj({
          selectedRule: res.selectedRule || res.list[0] || null,
          mandatoryRuleCoditions: res.mandatoryRuleCoditions || {},
        });
        setRuleList(res.list || []);
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };

  const getRolesAssignedToJourney = async (id) => {
    await Service.get(apiEndpoints.JOURNEY_ROLE_ASSIGN.replace('ID', id))
      .then((res) => {
        const deptRoleArr = [];
        const tempValue = [];
        res.forEach((v) => {
          deptRoles.forEach((value) => {
            value.forEach((val) => {
              if (v.departmentRoleId === val.id) {
                deptRoleArr.push({
                  id: val.id,
                  departmentId: val.departmentId.toString(),
                  title: val.title,
                });
                tempValue.push({
                  id: val.id,
                  departmentId: val.departmentId.toString(),
                  mandatory: v.mandatory,
                });
              }
            });
          });
        });
        setSelectedDeptRoles(tempValue);
        dispatch(getSelectedDeptRoles('add', tempValue));
        checkAllDeptOnLoad(deptRoles, tempValue);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const checkAllDeptOnLoad = (dept, selDept) => {
    const obj = [];
    obj.push(
      dept.map((value) => ({
        departmentId: value[0].departmentId.toString(),
        departmentRoleCount: value.length,
      })),
    );

    const obj2 = [];
    obj2.push(
      selDept.map((value) => ({
        departmentId: value.departmentId.toString(),
        departmentRoleCount: selDept.filter((item) => item.departmentId === value.departmentId).length,
      })),
    );

    const result = obj2[0].filter((o1) =>
      obj[0].some((o2) => o1.departmentId === o2.departmentId && o1.departmentRoleCount === o2.departmentRoleCount),
    );
    const ids = result.map((o) => o.departmentId);
    const filtered = result.filter(({ departmentId }, index) => !ids.includes(departmentId, index + 1));
    const deptArr = selectedDept;
    filtered?.forEach((val) => {
      const isfound = deptArr.includes(val.departmentId);
      if (!isfound) {
        deptArr.push(val.departmentId.toString());
        setSelectedDept([...deptArr]);
      }
    });
  };
  const openConfirm = () => {
    setShowConfirmPopup(true);
  };
  const closeConfirm = () => {
    setShowConfirmPopup(false);
  };

  const handleDeptSelectAll = (e) => {
    const deptId = e.target.value;
    const deptArr = selectedDept;
    let curArr = [];
    const indexes = [];
    const indexIds = [];
    const selectAllIndexes = [];
    const selectAllIndexIds = [];
    let i = 0;
    if (deptArr.indexOf(deptId.toString()) > -1) {
      const ind = deptArr.indexOf(deptId);
      deptArr.splice(ind, 1);
    } else {
      deptArr.push(deptId.toString());
    }
    setSelectedDept([...deptArr]);
    deptRoles?.forEach((val) => {
      val
        ?.filter((item) => item.departmentId.toString() === deptId)
        .forEach((value) => {
          if (e.target.checked === true) {
            const { id } = value;
            curArr = selectedDeptRoles;
            const index = curArr.map((x) => x.id).indexOf(id);
            selectAllIndexes.push(index);
            selectAllIndexIds.push(value.id);
          } else {
            const { id } = value;
            curArr = selectedDeptRoles;
            indexes[i] = curArr.map((x) => x.id).indexOf(id);
            indexIds[i] = id;
            i += 1;
          }
        });
    });
    if (indexes.length > 0) {
      indexes.forEach((val, key) => {
        const tempValue = {
          id: indexIds[key],
          mandatory: false,
        };
        if (val > -1) {
          const ind = curArr.findIndex((prop) => prop.id.toString() === indexIds[key].toString());
          curArr.splice(ind, 1);
          dispatch(getSelectedDeptRoles('remove', tempValue));
        }
      });
    }
    if (selectAllIndexes.length > 0) {
      selectAllIndexes.forEach((val, key) => {
        const tempValue = {
          id: selectAllIndexIds[key],
          departmentId: deptId,
          mandatory: false,
        };
        if (val < 0) {
          curArr.push(tempValue);
          dispatch(getSelectedDeptRoles('append', tempValue));
        }
      });
    }
    setSelectedDeptRoles([...curArr]);
  };
  const getDepartmentRoles = async (id) => {
    const data = '';
    await Service.get(apiEndpoints.JOURNEY_DEP_ROLE.replace('ID', id), data)
      .then((res) => {
        dispatch(getDepartmentRole('dept_roles', res));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const closePopup = () => {
    setShowConfirmPopup(false);
    dispatch(getDepartmentRole('clear', []));
    setViewJourneyPop(false);
    props.close();
  };
  const handleRoleCheckbox = (e) => {
    const deptArr = selectedDept;
    const eleValue = e.target.value;
    const deptId = document.getElementsByName(`dept_${e.target.value}`)[0].value;
    const tempVal = {
      id: parseInt(e.target.name, 10),
      departmentId: deptId,
      mandatory: false,
    };
    if (eleValue === deptId) {
      const id = e.target.name;
      const curArr = selectedDeptRoles;
      const index = curArr.map((x) => x.id.toString()).indexOf(id.toString());
      if (index < 0) {
        curArr.push(tempVal);
        dispatch(getSelectedDeptRoles('append', tempVal));
      } else {
        curArr.splice(index, 1);
        dispatch(getSelectedDeptRoles('remove', tempVal));
      }
      setSelectedDeptRoles([...curArr]);
      const selectedDeptRolesFilterArr = selectedDeptRoles.filter((item) => item.departmentId === e.target.value);
      const selectedDeptRolesFilterCount = selectedDeptRolesFilterArr.length;
      const getTotalDepartRoles = deptRoles[e.target.dataset.departmentkey].length;
      if (selectedDeptRolesFilterCount === getTotalDepartRoles) {
        deptArr.push(deptId.toString());
        setSelectedDept([...deptArr]);
      } else {
        const i = deptArr.indexOf(deptId);
        if (i > -1) {
          deptArr.splice(i, 1);
          setSelectedDept([...deptArr]);
        }
      }
    }
  };
  const getMandatory = (id) => {
    const index = selDeptRoles.map((x) => x.id.toString()).indexOf(id);
    return index;
  };
  const assignJourneyToRoles = async (data) => {
    await Service.post(apiEndpoints.JOURNEY_ASSIGN_TO_ROLE, data)
      .then(() => {
        closePopup();
        dispatch(showProgress(false));
        dispatch(getTempChecksDept('clear', []));
        dispatch(getTempChecksRoles('clear', []));
        notifySuccess('Journey Assigned To Roles Successfully');
      })
      .catch((error) => {
        console.log(error);
        ErrorToast(error);
        closePopup();
        dispatch(showProgress(false));
        dispatch(getTempChecksDept('clear', []));
        dispatch(getTempChecksRoles('clear', []));
      });
  };

  const assignJourneyToRule = async () => {
    if (!selectedRuleObj.selectedRule || !selectedRuleObj.selectedRule?.id) {
      ErrorToast('Please select a rule');
    } else {
      dispatch(showProgress(true));

      await Service.post(apiEndpoints.JOURNEY_ASSIGN_TO_RULE.replace('ID', selectedRuleObj.selectedRule.id), {
        journeyId: props.id,
        mandatoryRuleCoditions: selectedRuleObj.mandatoryRuleCoditions || {},
      })
        .then(() => {
          closePopup();
          dispatch(showProgress(false));
          dispatch(getTempChecksDept('clear', []));
          dispatch(getTempChecksRoles('clear', []));
          notifySuccess('Journey Mapped To Rule Successfully');
        })
        .catch((error) => {
          console.log(error);
          ErrorToast(error);
          closePopup();
          dispatch(showProgress(false));
          dispatch(getTempChecksDept('clear', []));
          dispatch(getTempChecksRoles('clear', []));
        });
    }
  };
  const submit = () => {
    selectedDeptRoles.forEach((v) => {
      // eslint-disable-next-line no-param-reassign
      delete v.departmentId;
    });
    const finArr = {
      journeyId: props.id,
      departmentRoles: selectedDeptRoles,
    };
    dispatch(showProgress(true));
    assignJourneyToRoles(finArr);
  };
  const setMandatoryFn = (e) => {
    const id = e.target.name.toString();
    const tempArr = selDeptRoles;
    const index = tempArr.map((x) => x.id.toString()).indexOf(id.toString());
    if (index >= 0) {
      tempArr[index].mandatory = e.target.checked;
    }
    setSelectedDeptRoles([...tempArr]);
    dispatch(getSelectedDeptRoles('add', tempArr));
  };
  const setAllRolesSelected = () => {
    const tempValue = [];
    deptRoles?.forEach((value) => {
      value.forEach((val) => {
        tempValue.push({
          id: val.id,
          departmentId: val.departmentId.toString(),
          mandatory: false,
        });
      });
    });
    setSelectedDeptRoles(tempValue);
    dispatch(getSelectedDeptRoles('add', tempValue));
    checkAllDeptOnLoad(deptRoles, tempValue);
  };
  const getContent = () =>
    deptRoles?.map((val, key) => (
      <Grid item xs={3} style={{ border: 'solid 1px #F2F2F2' }}>
        <Grid container direction="column">
          {val?.map((value) => (
            <Grid item style={{ paddingBottom: '5px', paddingTop: '5px' }}>
              <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
                <Grid item>
                  <Checkbox
                    style={{ padding: '0', margin: '9px' }}
                    key={value.id}
                    value={value.departmentId}
                    inputProps={{ 'data-departmentkey': key }}
                    checked={
                      selectedDept.indexOf(value.departmentId.toString()) > -1
                        ? true
                        : selectedDeptRoles.map((x) => x.id.toString()).indexOf(value.id.toString()) > -1
                    }
                    name={value.id.toString()}
                    onChange={handleRoleCheckbox}
                  />
                </Grid>
                <Grid item className={classes.connectingLineText2}>
                  {value.title}
                </Grid>
                <Grid item style={{ width: '28px' }}>
                  {getMandatory(value.id.toString()) > -1 ? (
                    <AntSwitch
                      defaultChecked={selDeptRoles[getMandatory(value.id.toString())].mandatory}
                      name={value.id.toString()}
                      onChange={setMandatoryFn}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    ));
  const getDeptContent = () =>
    departmentList?.map((value) => (
      <Grid item xs={3}>
        <Grid container direction="row" alignItems="center">
          <Grid item>
            <Checkbox
              checked={selectedDept?.indexOf(value.id?.toString()) > -1}
              style={{ padding: '0', margin: '9px' }}
              key={value.id}
              value={value.id}
              name={`dept_${value.id}`}
              onChange={handleDeptSelectAll}
            />
          </Grid>
          <Grid item className={classes.connectingLineText2}>
            {value.title}
          </Grid>
        </Grid>
      </Grid>
    ));

  return (
    <Modal
      isOpen={viewJourneyPop}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'hsla(50, 33%, 25%, 0.35)',
        },
        content: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          height: '80vh',
          width: '850px',
          overflow: 'auto',
        },
      }}
    >
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
        <Grid item xs={11}>
          <Grid
            container
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            style={{ height: '38px' }}
          >
            <Grid item className={classes.popupHeading}>
              {props.edit === false ? 'Add Journey' : 'Edit Journey'}
            </Grid>
          </Grid>
          <Grid container direction="row" style={{ marginBottom: '15px' }}>
            <Grid item xs={2}>
              <div className={classes.connectingLine}></div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.connectingLine2}></div>
            </Grid>
            <Grid item xs={7}></Grid>
          </Grid>
          <Grid container direction="row" style={{ marginBottom: '15px' }}>
            <Grid item xs={2}>
              <div className={classes.connectingLineText1}>Journey Info</div>
            </Grid>
            <Grid item xs={2}>
              <div className={classes.connectingLineText2}>Role Mapping</div>
            </Grid>
            <Grid item xs={8}></Grid>
          </Grid>
        </Grid>
        <Grid item xs={1}>
          <CloseIcon className={classes.popupCloseBtn} onClick={openConfirm} />
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent="flex-start">
        <Grid item className={classes.assignToText}>
          Assign To:
        </Grid>
        <Grid item>
          <FormControl>
            <RadioGroup
              row
              onChange={(e) => setAssignJourneyTo(e.target.value)}
              defaultValue="departments"
              value={assignJourneyTo}
            >
              <FormControlLabel
                value="departments"
                control={<Radio className={classes.radioButton} color="primary" />}
                label={<Typography className={classes.journeyAssignText}> Departments</Typography>}
                className={classes.smallRadioButton}
              />
              <FormControlLabel
                value="rule"
                control={<Radio className={classes.radioButton} color="primary" />}
                label={<Typography className={classes.journeyAssignText}> Rule</Typography>}
                className={classes.smallRadioButton}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
      <span className={classes.horizontalLine}></span>
      {assignJourneyTo === 'departments' ? (
        <DepartmentRoleMapping
          backButton={() => {
            closePopup();
            dispatch(getTempChecksDept('add', selectedDept));
            dispatch(getTempChecksRoles('add', selectedDeptRoles));
            props.journeyPop();
          }}
          submit={() => submit(props.edit)}
          classes={classes}
          getDeptContent={getDeptContent}
          getContent={getContent}
        />
      ) : (
        <JourneyRuleSelectMapping
          selectedRuleObj={selectedRuleObj}
          ruleList={ruleList}
          setSelectedRuleObj={setSelectedRuleObj}
          classes={classes}
          backButton={() => {
            closePopup();
            props.journeyPop();
          }}
          submit={assignJourneyToRule}
        />
      )}
      {showComfirmPopup && (
        <ConfirmPopup
          open
          type="journey"
          close={closeConfirm}
          closeJourneyPopup={() => {
            dispatch(getTempChecksDept('clear', []));
            dispatch(getTempChecksRoles('clear', []));
            closePopup();
          }}
        />
      )}
    </Modal>
  );
};

export default RoleMapping;
